import { render, staticRenderFns } from "./CompGoFlexRequestsTableMobile.vue?vue&type=template&id=608d9e5a&scoped=true"
import script from "./CompGoFlexRequestsTableMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGoFlexRequestsTableMobile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGoFlexRequestsTableMobile.vue?vue&type=style&index=0&id=608d9e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d9e5a",
  null
  
)

export default component.exports